/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PSP
 */
export interface PSP {
    /**
     * Get the Error Message from PSP
     * @type {string}
     * @memberof PSP
     */
    message?: string;
}

/**
 * Check if a given object implements the PSP interface.
 */
export function instanceOfPSP(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PSPFromJSON(json: any): PSP {
    return PSPFromJSONTyped(json, false);
}

export function PSPFromJSONTyped(json: any, ignoreDiscriminator: boolean): PSP {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function PSPToJSON(value?: PSP | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
    };
}

